import { render, staticRenderFns } from "./JcTicketEdit.vue?vue&type=template&id=255e1502&scoped=true&"
import script from "./JcTicketEdit.vue?vue&type=script&lang=js&"
export * from "./JcTicketEdit.vue?vue&type=script&lang=js&"
import style0 from "./JcTicketEdit.vue?vue&type=style&index=0&id=255e1502&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255e1502",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDialog,VForm,VIcon,VRow,VSpacer})
